import React from 'react';
import HeadshotComponent from '../../shared/components/headshot';

const EmployeeCard = ({ user, company }) => {
  console.log(user);
  return (
    <div className="card-grid">
      <HeadshotComponent user={ user } width={ 44 } className="hidden-xs" />
      <div>{user.given_name} {user.surname}</div>
      <div>{user.title}, {company.name}</div>
    </div>
  );
};

EmployeeCard.propTypes = {
};

export default EmployeeCard;
